<template>
    <div v-if="loading">
        <b-row>
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
    </div>
    <div v-else class="animated fadeIn">
        <component-header
            title="Payment History "
            @search-query="(val) => (filter = val)"
            :isLoading="loading"
            @reload-data="getCheckoutHistory"
            :hasback="false"
            :hasCreate="false"
        />
        <b-card
            class="card-wrap"
            border-variant="info"
            style="min-height: 450px"
        >
            <b-row>
                <b-col md="3" class="my-1">
                    <label>Time Period</label>
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <eb-select
                            type="select"
                            v-model="selectedPeriod"
                            :options="periodList"
                            label="text"
                            :id="'selecttime'"
                            :selected="selectedPeriod"
                            @input="changePeriod"
                        ></eb-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="my-1">
                    <label>Provider</label>
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <eb-select
                            type="select"
                            v-model="selectedProvider"
                            :options="partnerList"
                            :selected="selectedProvider"
                            label="partnerName"
                            :id="'selectprovider'"
                            placeholder="Select Provider"
                            @input="changeProvider"
                        ></eb-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="my-1">
                    <label>Payment Status</label>
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <eb-select
                            type="select"
                            v-model="selectedPaymentStatus"
                            :options="paymentStatusOptions"
                            :selected="selectedPaymentStatus"
                            label="text"
                            :id="'selectPayment'"
                            placeholder="Select Status"
                            @input="changePaymentStatus"
                        ></eb-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-table
                    style="border-radius: 12px"
                    responsive
                    :fields="Columns"
                    :items="historyData"
                    :dark="false"
                    :filter="filter"
                    :hover="true"
                    thead-class="header"
                    :striped="false"
                    :bordered="true"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :small="false"
                    show-empty
                    :fixed="false"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(createdAt)" slot-scope="data">
                        <div>{{ data.item.createdAt | formatedate }}</div>
                    </template>
                    <template slot="cell(empty)">
                        <div v-if="loading" class="text-center">
                            <span><b>Loading...</b></span>
                        </div>
                        <div v-else class="text-center">No data available.</div>
                    </template>
                </b-table>
            </div>
            <div style="float: right">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="historyData.length"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "paymenthistory",
    components: {
        ebButton,
        ebSelect,
        AtomSpinner,
        ComponentHeader,
    },
    data() {
        return {
            loading: false,
            currentPage: 1,
            filter: "",
            perPage: 10,
            sortBy: "createdAt",
            sortDesc: true,
            Columns: [
                {
                    key: "payment.orderId",
                    label: "Transaction ID",
                },
                {
                    key: "items[0].providerName",
                    label: "Provider",
                },
                {
                    key: "payment.type",
                    label: "Payment Type",
                },
                {
                    key: "totalPrice",
                    label: "Amount",
                    sortable: true,
                },
                {
                    key: "paymentStatus",
                    label: "Payment Status",
                },
                // {
                //   key: "orderStatus",
                //   label: "Order Status"
                // },
                {
                    key: "createdAt",
                    label: "Date",
                    sortable: true,
                },
            ],
            selectedPeriod: {
                text: "Last 7 days",
                value: 7,
            },
            selectedProvider: null,
            periodList: [
                {
                    text: "Last 7 days",
                    value: 7,
                },
                {
                    text: "Last 15 days",
                    value: 15,
                },
                {
                    text: "Last 30 days",
                    value: 30,
                },
                {
                    text: "Last 3 Months",
                    value: 90,
                },
                {
                    text: "Last 6 Months",
                    value: 180,
                },
            ],
            paymentStatusOptions: [
                { text: "PENDING", value: "PENDING" },
                { text: "REFUNDED", value: "REFUNDED" },
                { text: "PAID", value: "PAID" },
                { text: "CANCELLED", value: "CANCELLED" },
                { text: "FAILED", value: "FAILED" },
                { text: "INITIATED", value: "INITIATED" },
                { text: "INCOMPLETE", value: "INCOMPLETE" },
            ],
            selectedPaymentStatus: { text: "PENDING", value: "PENDING" },
        };
    },
    computed: {
        ...mapGetters({
            historyData: "order/GetCheckoutHistory",
        }),
        partnerList() {
            let data = this.$store.getters["partner/GetPartnerLiteList"];
            if (data.length > 0) {
                let partners = [];
                data.map((obj) => {
                    partners.push({
                        ...obj,
                        partnerName: obj.organization.name,
                    });
                });
                return partners;
            }
        },
    },
    methods: {
        ...mapActions({
            GetPartnerList: "partner/fetchPartnerListLite",
        }),
        changePeriod(event) {
            this.getCheckoutHistory();
        },
        changeProvider() {
            this.getCheckoutHistory();
        },
        changePaymentStatus() {
            this.getCheckoutHistory();
        },
        async getCheckoutHistory() {
            this.loading = true;
            let payload = {
                days: this.selectedPeriod.value,
                provider: this.selectedProvider
                    ? this.selectedProvider._id
                    : "",
                paymentStatus: this.selectedPaymentStatus.value,
            };
            await this.$store
                .dispatch("order/fetchCheckoutHistory", payload)
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
    async mounted() {
        this.loading = true;
        await this.getCheckoutHistory();
        await this.GetPartnerList({ type: "" });
        this.loading = false;
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
};
</script>
<style>
table.b-table[aria-busy="true"] {
    opacity: 0.6;
}
</style>
